<div class="text-center pt-4">
  <fgbcl-loading [color]="'black'"></fgbcl-loading>
</div>
